var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Javascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "16px",
    height: "16px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,4h-18c-1.105,0 -2,0.895 -2,2v18c0,1.105 0.895,2 2,2h18c1.105,0 2,-0.895 2,-2v-18c0,-1.105 -0.895,-2 -2,-2zM15,20.38c0,1.777 -1.09,2.773 -2.9,2.773c-1.788,0 -2.927,-1.045 -2.927,-2.735h1.937c0.005,0.627 0.379,1.023 0.957,1.023c0.594,0 0.913,-0.374 0.913,-1.078v-5.365h2.02zM20.481,23.153c-2.009,0 -3.273,-0.946 -3.307,-2.476h1.926c0.049,0.578 0.626,0.946 1.463,0.946c0.754,0 1.272,-0.363 1.272,-0.886c0,-0.44 -0.347,-0.677 -1.255,-0.858l-1.045,-0.209c-1.453,-0.275 -2.201,-1.067 -2.201,-2.316c0,-1.552 1.244,-2.57 3.158,-2.57c1.86,0 3.147,1.007 3.18,2.476h-1.865c-0.044,-0.561 -0.578,-0.952 -1.289,-0.952c-0.709,0 -1.176,0.336 -1.176,0.864c0,0.435 0.352,0.688 1.188,0.853l1.022,0.198c1.569,0.303 2.273,1.012 2.273,2.272c0.001,1.657 -1.264,2.658 -3.344,2.658z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Javascript);
export default __webpack_public_path__ + "static/media/icons8-javascript.1c52f38e465a74cb6b28d8499318e321.svg";
export { ForwardRef as ReactComponent };